import { Component } from '@angular/core';
import { UserRoleService } from '../../services/userRole.service';
import { TranslatePipe } from '@ngx-translate/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-videos',
  imports: [TranslatePipe, MatProgressSpinner, NgClass],
  templateUrl: './videos.component.html',
  styleUrl: './videos.component.scss',
  standalone: true,
})
export class VideosComponent {
  loading: boolean = true;
  constructor(protected userService: UserRoleService) {}
}
